var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7589 11.2751L17.8799 11.2061L17.4729 22.3291L19.3519 22.3981L19.7589 11.2751Z",
    fill: "#455079"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1251 11.24H14.2451V22.363H16.1251V11.24Z",
    fill: "#455079"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.892 22.3281L12.485 11.2051L10.606 11.2741L11.013 22.3971L12.892 22.3281Z",
    fill: "#455079"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.60303V8.48303H5.959L7.513 26.142C7.5335 26.3762 7.64098 26.5941 7.81424 26.753C7.98749 26.9118 8.21396 26.9999 8.449 27H21.89C22.125 26.9999 22.3515 26.9118 22.5248 26.753C22.698 26.5941 22.8055 26.3762 22.826 26.142L24.38 8.48303H26.37V6.60303H4ZM21.029 25.12H9.31L7.846 8.48303H22.493L21.029 25.12Z",
    fill: "#455079"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2561 3H12.1151C11.6996 3.00026 11.3012 3.16544 11.0074 3.45926C10.7135 3.75307 10.5484 4.15149 10.5481 4.567V7.543H12.4281V4.88H17.9421V7.543H19.8221V4.567C19.8218 4.15166 19.6568 3.75339 19.3632 3.45961C19.0696 3.16583 18.6714 3.00053 18.2561 3V3Z",
    fill: "#455079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2300337744880a14cf5fe054fbde1a5e.svg";
export { ForwardRef as ReactComponent };